import { KeyboardArrowDown } from '@mui/icons-material';
import { Box, Container, Typography, useMediaQuery, useTheme } from '@mui/material';
import { motion } from 'framer-motion';

const HeroSection = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box
      sx={{
        position: 'relative',
        minHeight: isMobile ? '40vh' : '50vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 50%, ${theme.palette.primary.light} 100%)`,
        overflow: 'hidden',
      }}
    >
      {/* Decorative pattern */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          opacity: 0.06,
          backgroundImage: `radial-gradient(circle at 20% 30%, #fff 1.5px, transparent 1.5px),
                           radial-gradient(circle at 80% 70%, #fff 1.5px, transparent 1.5px)`,
          backgroundSize: '60px 60px',
        }}
      />
      {/* Gradient overlay at bottom for smooth transition */}
      <Box
        sx={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          height: '80px',
          background: `linear-gradient(to top, ${theme.palette.background.default}, transparent)`,
        }}
      />

      <Container maxWidth="md" sx={{ position: 'relative', zIndex: 1, textAlign: 'center', py: 6 }}>
        <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }}>
          <Typography
            variant={isMobile ? 'h4' : 'h2'}
            sx={{
              color: '#fff',
              fontWeight: 900,
              mb: 2,
              textShadow: '0 2px 16px rgba(0,0,0,0.18)',
              letterSpacing: '-0.5px',
            }}
          >
            عقاركو
          </Typography>
          <Typography
            variant={isMobile ? 'body1' : 'h5'}
            sx={{
              color: 'rgba(255,255,255,0.9)',
              fontWeight: 400,
              maxWidth: 480,
              mx: 'auto',
              lineHeight: 1.7,
            }}
          >
            اكتشف أفضل العقارات المتاحة في منطقتك
          </Typography>
        </motion.div>
      </Container>

      {/* Scroll indicator */}
      <Box
        sx={{
          position: 'absolute',
          bottom: 24,
          left: '50%',
          transform: 'translateX(-50%)',
          zIndex: 1,
          cursor: 'pointer',
        }}
        onClick={() => {
          const el = document.getElementById('categories-section');
          if (el) el.scrollIntoView({ behavior: 'smooth' });
        }}
      >
        <motion.div
          animate={{ y: [0, 8, 0] }}
          transition={{ duration: 1.5, repeat: Infinity, ease: 'easeInOut' }}
        >
          <KeyboardArrowDown sx={{ color: 'rgba(255,255,255,0.6)', fontSize: 32 }} />
        </motion.div>
      </Box>
    </Box>
  );
};

export default HeroSection;
